import useScrollAnimation from "@/hooks/useScrollAnimation";
import { processData } from "@/mocks/homeData";

export default function ProcessSection() {
  const { ref, isVisible } = useScrollAnimation(0.1);

  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="process" className="w-full py-16 md:py-24 bg-background-50">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {processData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {processData.headline}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-2xl mx-auto">
            {processData.subheadline}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 max-w-6xl mx-auto">
          {processData.steps.map((step, index) => (
            <div key={step.number} className="relative">
              {index < processData.steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%-0.5rem)] w-[calc(100%-1rem)] h-px bg-primary-200/60" />
              )}
              <div className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70 h-full">
                <div className="flex items-center gap-3 mb-3">
                  <span className="font-heading font-bold text-xl md:text-2xl text-primary-500">
                    {step.number}
                  </span>
                  <span className="text-xs font-medium text-foreground-500 bg-background-200/70 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                    {step.duration}
                  </span>
                </div>
                <h4 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2">
                  {step.title}
                </h4>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                  {step.description}
                </p>
                <div className="flex items-center gap-1.5 text-xs font-medium text-primary-600 pt-3 border-t border-background-200/70">
                  <i className="ri-file-text-line text-xs" />
                  <span>{step.deliverable}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => handleNavClick("#case-studies")}
            className="px-6 py-3 text-sm font-semibold rounded-md border border-primary-300 text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            See How This Process Delivered Results
          </button>
        </div>
      </div>
    </section>
  );
}